import React, { useEffect, useMemo, useState, createElement, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '../components/NavBar';
import { StatCard } from '../components/StatCard';
import { Card } from '../components/SubscriptionAppCard';
import { Button } from '../components/SubscriptionAppButton';
import { Badge } from '../components/SubscriptionAppBadge';
import { TableFilter } from '../components/TableFilter';
import type { Filter } from '../components/TableFilter';
import { Download, Lightbulb, Sparkles } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Mock cohort data
const cohortData2025 = [{
  cohort: 'Jan 2025',
  size: 89,
  m0: 100,
  m1: 94,
  m2: 89,
  m3: 85,
  m4: 82,
  m5: 80,
  m6: 78,
  m7: 76,
  m8: 74,
  m9: 72,
  m10: 70,
  m11: 69,
  m12: 68
}, {
  cohort: 'Feb 2025',
  size: 72,
  m0: 100,
  m1: 92,
  m2: 87,
  m3: 83,
  m4: 79,
  m5: 76,
  m6: 74,
  m7: 72,
  m8: 70,
  m9: 68,
  m10: 67,
  m11: null,
  m12: null
}, {
  cohort: 'Mar 2025',
  size: 95,
  m0: 100,
  m1: 96,
  m2: 92,
  m3: 89,
  m4: 86,
  m5: 84,
  m6: 82,
  m7: 80,
  m8: 78,
  m9: 76,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Apr 2025',
  size: 81,
  m0: 100,
  m1: 91,
  m2: 86,
  m3: 82,
  m4: 78,
  m5: 75,
  m6: 73,
  m7: 71,
  m8: 69,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'May 2025',
  size: 67,
  m0: 100,
  m1: 93,
  m2: 88,
  m3: 84,
  m4: 81,
  m5: 78,
  m6: 76,
  m7: 74,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Jun 2025',
  size: 104,
  m0: 100,
  m1: 95,
  m2: 91,
  m3: 88,
  m4: 85,
  m5: 82,
  m6: 80,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Jul 2025',
  size: 78,
  m0: 100,
  m1: 90,
  m2: 84,
  m3: 80,
  m4: 77,
  m5: 74,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Aug 2025',
  size: 92,
  m0: 100,
  m1: 94,
  m2: 90,
  m3: 86,
  m4: 83,
  m5: null,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Sep 2025',
  size: 85,
  m0: 100,
  m1: 93,
  m2: 88,
  m3: 85,
  m4: null,
  m5: null,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Oct 2025',
  size: 71,
  m0: 100,
  m1: 91,
  m2: 86,
  m3: null,
  m4: null,
  m5: null,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Nov 2025',
  size: 88,
  m0: 100,
  m1: 94,
  m2: null,
  m3: null,
  m4: null,
  m5: null,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}, {
  cohort: 'Dec 2025',
  size: 65,
  m0: 100,
  m1: null,
  m2: null,
  m3: null,
  m4: null,
  m5: null,
  m6: null,
  m7: null,
  m8: null,
  m9: null,
  m10: null,
  m11: null,
  m12: null
}];
const cohortData2024 = [{
  cohort: 'Jan 2024',
  size: 62,
  m0: 100,
  m1: 91,
  m2: 84,
  m3: 79,
  m4: 74,
  m5: 70,
  m6: 66,
  m7: 63,
  m8: 60,
  m9: 58,
  m10: 56,
  m11: 54,
  m12: 52
}, {
  cohort: 'Feb 2024',
  size: 58,
  m0: 100,
  m1: 89,
  m2: 82,
  m3: 76,
  m4: 71,
  m5: 67,
  m6: 63,
  m7: 60,
  m8: 57,
  m9: 55,
  m10: 53,
  m11: 51,
  m12: 49
}, {
  cohort: 'Mar 2024',
  size: 71,
  m0: 100,
  m1: 92,
  m2: 86,
  m3: 81,
  m4: 76,
  m5: 72,
  m6: 68,
  m7: 65,
  m8: 62,
  m9: 60,
  m10: 58,
  m11: 56,
  m12: 54
}, {
  cohort: 'Apr 2024',
  size: 55,
  m0: 100,
  m1: 88,
  m2: 80,
  m3: 74,
  m4: 69,
  m5: 65,
  m6: 61,
  m7: 58,
  m8: 55,
  m9: 53,
  m10: 51,
  m11: 49,
  m12: 47
}, {
  cohort: 'May 2024',
  size: 63,
  m0: 100,
  m1: 90,
  m2: 83,
  m3: 77,
  m4: 72,
  m5: 68,
  m6: 64,
  m7: 61,
  m8: 58,
  m9: 56,
  m10: 54,
  m11: 52,
  m12: 50
}, {
  cohort: 'Jun 2024',
  size: 74,
  m0: 100,
  m1: 93,
  m2: 87,
  m3: 82,
  m4: 77,
  m5: 73,
  m6: 69,
  m7: 66,
  m8: 63,
  m9: 61,
  m10: 59,
  m11: 57,
  m12: 55
}, {
  cohort: 'Jul 2024',
  size: 68,
  m0: 100,
  m1: 91,
  m2: 85,
  m3: 80,
  m4: 75,
  m5: 71,
  m6: 67,
  m7: 64,
  m8: 61,
  m9: 59,
  m10: 57,
  m11: 55,
  m12: 53
}, {
  cohort: 'Aug 2024',
  size: 77,
  m0: 100,
  m1: 94,
  m2: 88,
  m3: 83,
  m4: 78,
  m5: 74,
  m6: 70,
  m7: 67,
  m8: 64,
  m9: 62,
  m10: 60,
  m11: 58,
  m12: 56
}, {
  cohort: 'Sep 2024',
  size: 60,
  m0: 100,
  m1: 90,
  m2: 83,
  m3: 77,
  m4: 72,
  m5: 68,
  m6: 64,
  m7: 61,
  m8: 58,
  m9: 56,
  m10: 54,
  m11: 52,
  m12: 50
}, {
  cohort: 'Oct 2024',
  size: 82,
  m0: 100,
  m1: 95,
  m2: 89,
  m3: 84,
  m4: 79,
  m5: 75,
  m6: 71,
  m7: 68,
  m8: 65,
  m9: 63,
  m10: 61,
  m11: 59,
  m12: 57
}, {
  cohort: 'Nov 2024',
  size: 69,
  m0: 100,
  m1: 92,
  m2: 86,
  m3: 81,
  m4: 76,
  m5: 72,
  m6: 68,
  m7: 65,
  m8: 62,
  m9: 60,
  m10: 58,
  m11: 56,
  m12: 54
}, {
  cohort: 'Dec 2024',
  size: 73,
  m0: 100,
  m1: 93,
  m2: 87,
  m3: 82,
  m4: 77,
  m5: 73,
  m6: 69,
  m7: 66,
  m8: 63,
  m9: 61,
  m10: 59,
  m11: 57,
  m12: 55
}];
// Average retention curve data
const retentionCurveData = [{
  month: 'M0',
  retention: 100
}, {
  month: 'M1',
  retention: 94
}, {
  month: 'M2',
  retention: 89
}, {
  month: 'M3',
  retention: 85
}, {
  month: 'M4',
  retention: 82
}, {
  month: 'M5',
  retention: 79
}, {
  month: 'M6',
  retention: 76
}, {
  month: 'M7',
  retention: 74
}, {
  month: 'M8',
  retention: 72
}, {
  month: 'M9',
  retention: 70
}, {
  month: 'M10',
  retention: 68
}, {
  month: 'M11',
  retention: 67
}, {
  month: 'M12',
  retention: 65
}];
export function CohortRetentionPage() {
  const navigate = useNavigate();
  const [periodRange, setPeriodRange] = useState('Last 12 Months');
  const [filterValues, setFilterValues] = useState<Record<string, string[]>>({
    acquisitionSource: [],
    clubTier: []
  });
  const [addedFilters, setAddedFilters] = useState<Set<string>>(new Set());
  const [openFilterDropdowns, setOpenFilterDropdowns] = useState<Set<string>>(new Set());
  const activeCohortData = useMemo(() => {
    if (periodRange === 'Last 12 Months') {
      return cohortData2025;
    }
    return [...cohortData2024, ...cohortData2025];
  }, [periodRange]);
  const statCards = useMemo(() => {
    if (periodRange === 'Last 12 Months') {
      return {
        avgRetM6: '78%',
        avgRetM6Trend: '+2% vs previous period',
        avgRetM6TrendColor: 'text-[#10B981]',
        avgRetM12: '65%',
        avgRetM12Trend: '-1% vs previous period',
        avgRetM12TrendColor: 'text-[#EF4444]',
        bestCohort: 'Mar 2025',
        bestCohortDetail: '82% at M6',
        cohortsAnalyzed: '12',
        totalMembers: '847 total members'
      };
    }
    return {
      avgRetM6: '68%',
      avgRetM6Trend: '-10% vs previous period',
      avgRetM6TrendColor: 'text-[#EF4444]',
      avgRetM12: '53%',
      avgRetM12Trend: '-12% vs previous period',
      avgRetM12TrendColor: 'text-[#EF4444]',
      bestCohort: 'Oct 2024',
      bestCohortDetail: '71% at M6',
      cohortsAnalyzed: '24',
      totalMembers: '1,694 total members'
    };
  }, [periodRange]);
  const tableFilters: Filter[] = [{
    id: 'acquisitionSource',
    label: 'Acquisition Source',
    options: [{
      id: '1',
      label: 'Website',
      value: 'website'
    }, {
      id: '2',
      label: 'Cellar Door',
      value: 'cellar-door'
    }, {
      id: '3',
      label: 'Event',
      value: 'event'
    }, {
      id: '4',
      label: 'Referral',
      value: 'referral'
    }],
    selectedValues: filterValues.acquisitionSource || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('acquisitionSource')
  }, {
    id: 'clubTier',
    label: 'Club Tier',
    options: [{
      id: '1',
      label: 'Gold',
      value: 'gold'
    }, {
      id: '2',
      label: 'Silver',
      value: 'silver'
    }, {
      id: '3',
      label: 'Bronze',
      value: 'bronze'
    }],
    selectedValues: filterValues.clubTier || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('clubTier')
  }];
  const handleAddFilter = (filterId: string) => {
    const newAddedFilters = new Set(addedFilters);
    newAddedFilters.add(filterId);
    setAddedFilters(newAddedFilters);
  };
  const handleFilterChange = (filterId: string, value: string | string[]) => {
    const newFilterValues = {
      ...filterValues,
      [filterId]: Array.isArray(value) ? value : [value]
    };
    setFilterValues(newFilterValues);
  };
  const handleFilterRemove = (filterId: string) => {
    const newAddedFilters = new Set(addedFilters);
    newAddedFilters.delete(filterId);
    setAddedFilters(newAddedFilters);
    setFilterValues(prev => ({
      ...prev,
      [filterId]: []
    }));
  };
  const handleToggleFilterDropdown = (filterId: string) => {
    const newOpenFilterDropdowns = new Set(openFilterDropdowns);
    if (newOpenFilterDropdowns.has(filterId)) {
      newOpenFilterDropdowns.delete(filterId);
    } else {
      newOpenFilterDropdowns.add(filterId);
    }
    setOpenFilterDropdowns(newOpenFilterDropdowns);
  };
  const getRetentionColor = (value: number | null) => {
    if (value === null) return '';
    if (value >= 90) return 'bg-[#D1FAE5] text-[#065F46]';
    if (value >= 70) return 'bg-[#A7F3D0] text-[#047857]';
    if (value >= 50) return 'bg-[#FEF3C7] text-[#92400E]';
    return 'bg-[#FED7AA] text-[#C2410C]';
  };
  const handleExportCSV = () => {
    const months = ['M0', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10', 'M11', 'M12'];
    const headers = ['Cohort', 'Size', ...months];
    const rows = activeCohortData.map(row => [row.cohort, row.size, row.m0, row.m1, row.m2, row.m3, row.m4, row.m5, row.m6, row.m7, row.m8, row.m9, row.m10, row.m11, row.m12].map(v => v === null ? '' : v));
    const csvContent = [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `cohort-retention-${periodRange.replace(/\s+/g, '-').toLowerCase()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return <>
      <div className="md:hidden fixed inset-0 bg-[#64748B] bg-opacity-95 z-50 flex items-center justify-center p-6" data-id="element-5280">
        <div className="bg-white rounded-lg p-8 max-w-md text-center shadow-xl" data-id="element-5281">
          <div className="w-16 h-16 bg-[#E0F2FE] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-5282">
            <svg className="w-8 h-8 text-[#0EA5E9]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-5283">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-5284" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-[#0F172A] mb-3" data-id="element-5285">
            Desktop or Tablet Required
          </h2>
          <p className="text-sm text-[#475569] leading-relaxed mb-6" data-id="element-5286">
            Please use this app on desktop or tablet as the mobile version is
            not supported yet. We will be rolling out a support update soon.
          </p>
          <div className="text-xs text-[#94A3B8]" data-id="element-5287">
            Minimum screen width: 768px
          </div>
        </div>
      </div>

      <div className="hidden md:block bg-[#F1F5F9] min-h-full p-4 sm:p-6" data-id="element-5288">
        <div className="mb-6" data-id="element-5289">
          <NavBar tabs={[]} title="Member Retention" data-id="element-5290" />
        </div>

        <div className="mb-6 sm:mb-8" data-id="element-5291">
          <p className="text-sm sm:text-[16px] text-[#475569]" data-id="element-5292">
            Understand how your wine club retains members over time
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8" data-id="element-5293">
          <StatCard label="Average Retention at Month 6" value={statCards.avgRetM6} trend={<span className={`text-xs ${statCards.avgRetM6TrendColor} flex items-center gap-1`} data-id="element-5295">
                <span data-id="element-5296">{statCards.avgRetM6Trend}</span>
              </span>} data-id="element-5294" />
          <StatCard label="Average Retention at Month 12" value={statCards.avgRetM12} trend={<span className={`text-xs ${statCards.avgRetM12TrendColor} flex items-center gap-1`} data-id="element-5298">
                <span data-id="element-5299">{statCards.avgRetM12Trend}</span>
              </span>} data-id="element-5297" />
          <StatCard label="Best Performing Cohort" value={statCards.bestCohort} trend={<span className="text-xs text-[#64748B]" data-id="element-5301">
                {statCards.bestCohortDetail}
              </span>} data-id="element-5300" />
          <StatCard label="Cohorts Analyzed" value={statCards.cohortsAnalyzed} trend={<span className="text-xs text-[#64748B]" data-id="element-5303">
                {statCards.totalMembers}
              </span>} data-id="element-5302" />
        </div>

        <div className="bg-white border border-[#E2E8F0] rounded-lg mb-6 p-4 shadow-[0_1px_3px_rgba(15,23,42,0.08)]" data-id="element-5304">
          <div className="flex flex-col gap-3" data-id="element-5305">
            <div className="flex items-center justify-between gap-3" data-id="element-5306">
              <div className="flex items-center gap-3" data-id="element-5307">
                <TableFilter filters={tableFilters} onFilterChange={handleFilterChange} onFilterRemove={handleFilterRemove} onToggleDropdown={handleToggleFilterDropdown} addedFilterIds={addedFilters} onAddFilter={handleAddFilter} renderOnlyButton={true} data-id="element-5308" />
              </div>
              <div className="flex items-center gap-3" data-id="element-5309">
                <select value={periodRange} onChange={e => setPeriodRange(e.target.value)} className="h-10 pl-3 pr-10 text-[14px] border border-[#CBD5E1] rounded-md bg-white text-[#0F172A] outline-none focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all duration-200 appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23475569%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:20px_20px] bg-[right_12px_center] bg-no-repeat hover:border-[#94A3B8] cursor-pointer" data-id="element-5310">
                  <option data-id="element-5311">Last 12 Months</option>
                  <option data-id="element-5312">Last 24 Months</option>
                  <option data-id="element-5313">All Time</option>
                </select>
                <Button variant="outline" size="md" onClick={handleExportCSV} iconLeft={<Download className="w-4 h-4" data-id="element-5315" />} data-id="element-5314">
                  Export
                </Button>
              </div>
            </div>

            {addedFilters.size > 0 && <div className="w-full" data-id="element-5316">
                <TableFilter filters={tableFilters} onFilterChange={handleFilterChange} onFilterRemove={handleFilterRemove} onToggleDropdown={handleToggleFilterDropdown} addedFilterIds={addedFilters} onAddFilter={handleAddFilter} renderOnlyChips={true} data-id="element-5317" />
              </div>}
          </div>
        </div>

        <Card className="mb-6 sm:mb-8 overflow-hidden" data-id="element-5318">
          <div className="px-4 py-3 border-b border-[#E2E8F0]" data-id="element-5319">
            <h2 className="text-sm font-semibold text-[#0F172A]" data-id="element-5320">
              Cohort Retention Heatmap
            </h2>
          </div>
          <div className="overflow-x-auto" data-id="element-5321">
            <table className="w-full table-fixed" data-id="element-5322">
              <thead className="bg-[#F1F5F9]" data-id="element-5323">
                <tr data-id="element-5324">
                  <th className="px-2.5 py-2 text-left text-[11px] font-semibold text-[#475569] uppercase tracking-wider w-[110px] sticky left-0 bg-[#F1F5F9] z-10" data-id="element-5325">
                    Cohort
                  </th>
                  {['M0', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10', 'M11', 'M12'].map(month => <th key={month} className="px-1 py-2 text-center text-[11px] font-semibold text-[#64748B] uppercase tracking-wider" data-id="element-5326">
                      {month}
                    </th>)}
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E2E8F0]" data-id="element-5327">
                {activeCohortData.map(row => <tr key={row.cohort} className="hover:bg-[#F8FAFC]" data-id="element-5328">
                    <td className="px-2.5 py-1.5 text-xs font-medium text-[#0F172A] bg-[#F8FAFC] sticky left-0 z-10 whitespace-nowrap" data-id="element-5329">
                      {row.cohort} ({row.size})
                    </td>
                    {[row.m0, row.m1, row.m2, row.m3, row.m4, row.m5, row.m6, row.m7, row.m8, row.m9, row.m10, row.m11, row.m12].map((value, idx) => <td key={idx} className="px-1 py-1.5 text-center border border-[#E2E8F0]" aria-label={value !== null ? `${row.cohort} cohort, month ${idx} retention: ${value}%` : `${row.cohort} cohort, month ${idx}: no data yet`} data-id="element-5330">
                        {value !== null ? <span className={`inline-block px-1.5 py-0.5 rounded text-xs font-medium ${getRetentionColor(value)}`} data-id="element-5331">
                            {value}%
                          </span> : <span className="text-[#94A3B8] text-xs" data-id="element-5332">—</span>}
                      </td>)}
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8" data-id="element-5333">
          <Card className="border-l-4 border-l-[#FCD34D] bg-[#FFFBEB]" data-id="element-5334">
            <div className="flex gap-3 sm:gap-4 p-4 sm:p-6" data-id="element-5335">
              <div className="flex-shrink-0" data-id="element-5336">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#FEF3C7] flex items-center justify-center" data-id="element-5337">
                  <Lightbulb className="w-5 h-5 sm:w-6 sm:h-6 text-[#F59E0B]" data-id="element-5338" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-5339">
                <h3 className="text-sm sm:text-base font-semibold text-[#0F172A] mb-2" data-id="element-5340">
                  Want a specific report?
                </h3>
                <p className="text-xs sm:text-sm text-[#78350F] mb-3 sm:mb-4" data-id="element-5341">
                  We're building reports based on what wineries actually need.
                  Tell us what you'd find useful.
                </p>
                <button className="text-xs sm:text-sm font-medium text-[#F59E0B] hover:underline" data-id="element-5342">
                  Share feedback →
                </button>
              </div>
            </div>
          </Card>

          <Card className="border-l-4 border-l-[#7DD3FC] bg-[#F0F9FF]" data-id="element-5343">
            <div className="flex gap-3 sm:gap-4 p-4 sm:p-6" data-id="element-5344">
              <div className="flex-shrink-0" data-id="element-5345">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-5346">
                  <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-[#0EA5E9]" data-id="element-5347" />
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-5348">
                <div className="flex items-center gap-2 mb-2" data-id="element-5349">
                  <h3 className="text-sm sm:text-base font-semibold text-[#0F172A]" data-id="element-5350">
                    Need custom analysis?
                  </h3>
                  <Badge variant="info" data-id="element-5351">Coming Soon</Badge>
                </div>
                <p className="text-xs sm:text-sm text-[#0C4A6E] mb-3 sm:mb-4" data-id="element-5352">
                  Ask WinePik can answer questions about your data — try "What's
                  my churn rate by tier?" or "Which month had the best
                  retention?"
                </p>
                <Button variant="outline" size="sm" iconLeft={<Sparkles className="w-4 h-4" data-id="element-5354" />} data-id="element-5353">
                  Ask WinePik
                </Button>
              </div>
            </div>
          </Card>
        </div>

        <Card className="mb-6 sm:mb-8" data-id="element-5355">
          <div className="p-4 sm:p-6 border-b border-[#E2E8F0]" data-id="element-5356">
            <h2 className="text-sm sm:text-base font-semibold text-[#0F172A]" data-id="element-5357">
              Average Retention Curve
            </h2>
          </div>
          <div className="p-4 sm:p-6" data-id="element-5358">
            <ResponsiveContainer width="100%" height={280} data-id="element-5359">
              <LineChart data={retentionCurveData} margin={{
              top: 5,
              right: 10,
              left: 0,
              bottom: 5
            }} data-id="element-5360">
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" data-id="element-5361" />
                <XAxis dataKey="month" stroke="#94A3B8" style={{
                fontSize: '12px'
              }} data-id="element-5362" />
                <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} stroke="#94A3B8" style={{
                fontSize: '12px'
              }} tickFormatter={value => `${value}%`} data-id="element-5363" />
                <Tooltip contentStyle={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #CBD5E1',
                borderRadius: '6px',
                fontSize: '12px'
              }} formatter={(value: number) => [`${value}%`, 'Retention']} data-id="element-5364" />
                <Line type="monotone" dataKey="retention" stroke="#0EA5E9" strokeWidth={2} dot={{
                fill: '#0EA5E9',
                r: 3
              }} activeDot={{
                r: 5
              }} data-id="element-5365" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </>;
}